import React , { useState,useEffect }from 'react'
import { Button,  Form, Input,message, Tree,Modal,Select, } from 'antd';
// import Icon,{EditOutlined  } from '@ant-design/icons';
// import './index.css';
import {api_user_edit_password} from '../../../api';
import CryptoJs from 'crypto-js';

// const navigate = useNavigate();
  // navigate(-1)//适用于返回上级页面
  // navigate('/router');//也可直接加路径

// const { Header, Content, Footer, Sider } = Layout;
// const { TextArea } = Input;
// const { Option } = Select;
const screenHeight = document.body.clientHeight;
var PathBASE=window.location.href;
// console.log('PathBASE -------- ', PathBASE);
    PathBASE = PathBASE.split("#/")[0]; 

const App =(props)=>{
    const [form] = Form.useForm();
    const [loading,setLoading] = useState(false);

    useEffect(() => {
    }, []);

    // const validatePasswords = (_, value) => {
    //   const { newPassword2 } = form.getFieldsValue();
    //   if (value && newPassword2 && value!== newPassword2) {
    //       return Promise.reject('两次输入的新密码不一致');
    //   }
    //   return Promise.resolve();
    // };

    const validatePasswordsReverse = (_, value) => {
        const { newPassword1 } = form.getFieldsValue();
        if (value && newPassword1 && value!== newPassword1) {
            return Promise.reject('两次输入的新密码不一致');
        }
        return Promise.resolve();
    };

    const onFinish = async(value)=>{
      console.log(value);
      try {
        value.oldPassword = CryptoJs.MD5(value.oldPassword).toString();
        value.newPassword1 = CryptoJs.MD5(value.newPassword1).toString();
        delete value.newPassword2;
        await api_user_edit_password(value).then((res) => {
          setLoading(false);
          console.log('api_user_edit_password-res-----------------', res);
          if (res.data.code == 9) {
            message.success("修改成功");
            window.location.href=PathBASE+'#/login';
          }else
            message.error(res.data.msg);
        });
        } catch (error) {
          message.error("网络异常");
          setLoading(false);
          return false;
        }
  }

  return (
    <div style={{backgroundColor:"white",padding:50}}>
      <Form form={form}
        className='loginForm reginfo'
        name="changePasswordForm"
        // labelCol={{span: 5}}
        // wrapperCol={{span: 16}}
        onFinish={onFinish}
        layout="horizontal"
        // onFinishFailed={this.onFinishFailed}
        autoComplete="off"
        labelAlign="left"
        labelCol={{span:5}}
        // style={{fontSize:12}}
        // size="small"
        style={{ textAlign: 'center',width:"50%" }}
      >
        <Form.Item
            label="旧密码"
            name="oldPassword"
            rules={[
              {required: true,message: '密码必须6-30个字符',},
              {max: 30,message: '密码最多30位',},
              {min: 6,message: '密码至少6位',},
            ]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
            label="新密码"
            name="newPassword1"
            rules={[
              {required: true,message: '密码必须6-30个字符',},
              {max: 30,message: '密码最多30位',},
              {min: 6,message: '密码至少6位',},
              // {
              //   validator: validatePasswords,
              // },
            ]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
            label="确认密码"
            name="newPassword2"
            rules={[
              {required: true,message: '密码必须6-30个字符',},
              {max: 30,message: '密码最多30位',},
              {min: 6,message: '密码至少6位',},
              {
                validator: validatePasswordsReverse,
              },
            ]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item style={{marginTop:50}}>
            <Button type="primary" htmlType="submit" loading={loading}>
                修改密码
            </Button>
        </Form.Item>
      </Form>
    </div>
  )
}
export default App
